import script from "./Student.vue?vue&type=script&setup=true&lang=js"
export * from "./Student.vue?vue&type=script&setup=true&lang=js"

import "./Student.vue?vue&type=style&index=0&id=420a0ddd&lang=css"

const __exports__ = script;

export default __exports__